import { BmsBillingPeriod, BmsMonthOfYear } from "../../../core/models/bms-export-bot";

export class BmsSystemObjectCurve {
  id : string;
  name : string;
  systemId : string;
  unit : string;
  key : string;
  points : number;

  in1 : number;
  out1 : number;
  in2 : number;
  out2 : number;
  in3 : number;
  out3 : number;
  in4 : number;
  out4 : number;
  in5 : number;
  out5 : number;
  in6 : number;
  out6 : number;
  in7 : number;
  out7 : number;
  in8 : number;
  out8 : number;
  in9 : number;
  out9 : number;
  in10 : number;
  out10 : number;

  createdAt : Date;
  modifiedAt : Date;
}
